'use client';

import { CircleUserRound } from 'lucide-react';

import { SignInButton } from '@clerk/nextjs';

function AppNavSigninButton() {
  return (
    <SignInButton>
      <CircleUserRound size={28} />
    </SignInButton>
  );
}

export default AppNavSigninButton;
